module.exports = __webpack_public_path__ + "img/As.54f71218.png";